/* tslint:disable */
/* eslint-disable */
export enum ListRDataItemSortBy {
  ContractCreatedDate = 'ContractCreatedDate',
  Salary = 'Salary',
  SigningBonus = 'SigningBonus',
  GuaranteedCompensation = 'GuaranteedCompensation'
}
